import { CSSProperties } from 'react';
import { Chip } from '@mui/material';
import { SupervisedUserCircle } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { chipColors } from '../../lib/contrast';

type GroupType = 'NORMAL' | 'SPORT' | 'ABONADOS' | 'FAMILY';

type Props = {
    type: GroupType | string;
    icon?: boolean;
};

/*
 * Chip to repreent a group
 * Props:
 *   type: should be any of 'NORMAL', 'SPORT' or 'ABONADOS' but can technically be anything
 * */
export function SttChipGroup({
    type,
    icon = false,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    const color: Record<string, string> = {
        NORMAL: '#578BC1',
        SPORT: '#EA9935',
        ABONADOS: '#CE65F1',
        FAMILY: '#46a300',
    };
    let style: CSSProperties;
    let iconStyle: CSSProperties;

    if (color[type]) {
        style = chipColors(color[type]!);
        iconStyle = { color: style.color };
    } else {
        style = { backgroundColor: '#f0f0f0', color: '#2b2b2b' }; // Fallback color in case the group's color is unspecified
        iconStyle = { color: '#2b2b2b' };
    }

    return (
        <Chip
            size="small"
            icon={icon ? <SupervisedUserCircle style={iconStyle} /> : undefined}
            label={t(`GT.${type}`)}
            style={style}
        />
    );
}
